export default "/images/vendor/flag-icon-css/flags/4x3/ca.svg?e833b599aaaaf371fa4313751271c4f5";